<template>
    <el-dialog :title="editSource.id?'Edit Source':'Add a new Source'" :visible.sync="visible" width="45%"
               :close-on-click-modal="false">
        <div class="dialog-content">
            <el-form :rules="rules" ref="addNewSourceForm" :model="form" @submit="submitForm" label-position="left"
                     size="small" label-width="200px">
                <el-form-item label="Source Name" prop="source.name">
                    <el-input v-model="form.source.name"
                              maxlength="200"
                              show-word-limit
                              placeholder="Enter Source Name"></el-input>
                </el-form-item>
                <el-form-item label="Source Abbreviation" prop="source.abbreviation">
                    <el-input v-model="form.source.abbreviation"
                              placeholder="Enter Source Abbreviation"></el-input>
                </el-form-item>
                <el-form-item label="URL" prop="source.url">
                    <el-input v-model="form.source.url" placeholder="Enter Source url"></el-input>
                </el-form-item>
                <el-form-item label="Status" prop="source.status">
                    <el-select v-model="form.source.status" placeholder="Select Status">
                        <el-option
                                v-for="item in source_status"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Type" prop="source.type">
                    <el-select :disabled="Boolean(setSourceType) || Boolean(editSource.id)"
                               v-model="form.source.type"
                               @change="form.source.parent_source_id=null">
                        <el-option
                                v-for="item in sourceTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-collapse-transition>
                    <div v-show="form.source.type==='qual'">
                        <el-form-item v-if="Object.keys(sourceData).length " label="Parent Source">
                            <el-select :disabled="disallowParentChange" filterable default-first-option
                                       :filter-method="filterSourceSelectMethod"
                                       v-model="form.source.parent_source_id"
                                       clearable
                                       placeholder="Select Parent Source">
                                <el-option
                                        v-for="obj in sourceSelect.filter(row=>(form.source.type===row.type && !row.parent_source_id && row.id !== editSource.id))"
                                        :label="obj.abbreviation"
                                        :value="obj.id"
                                        :key="obj.abbreviation">
                                    <span class="source-abbr" v-text="obj.abbreviation"></span>
                                    <span class="source-name" v-text="obj.name"></span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-collapse-transition>
                <el-form-item label="Expected Published Date">
                    <el-date-picker
                            type="date"
                            v-model="editSourceDateExpectedPublish"
                            placeholder="Pick date" :picker-options="datePickerOptions">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false" size="medium">Cancel</el-button>
            <el-button v-if="editSource.id" type="primary" @click="updateSource" size="medium">Update Source</el-button>
            <el-button v-else type="primary" @click="submitForm" size="medium">Add Source</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {API} from "@/api/index";
    import {createNamespacedHelpers} from 'vuex';

    const {mapState, mapActions, mapMutations} = createNamespacedHelpers('riskIndex');

    export default {
        name:     "AddNewSourceDialog",
        props:    {
            setSourceType: {
                default: ''
            }
        },
        data() {
            let checkDuplicateSourceAbbreviation = (rule, value, callback) => {
                if (value !== this.editSource.abbreviation && rule.allAbbreviations.includes(value)) {
                    return callback(new Error('Please enter unique Source Abbreviation'));
                } else if (/[^A-Z0-9-]/g.test(value)) {
                    return callback(new Error('Only uppercase, numbers(0-9) and dash(-) are allowed'));
                }
                callback();
            };
            return {
                visible:              false,
                form:                 {
                    source: {
                        name:                  '',
                        abbreviation:          '',
                        url:                   null,
                        status:                null,
                        type:                  'quant',
                        parent_source_id:      null,
                        date_expected_publish: null
                    }
                },
                sourceSelect:         [],
                source_status:        [
                    {
                        value: 'active',
                        label: 'Active'
                    }, {
                        value: 'inactive',
                        label: 'Inactive'
                    }, {
                        value: 'analysis',
                        label: 'Under Analysis'
                    }
                ],
                sourceTypes:          [
                    {
                        value: 'quant',
                        label: 'Quantitative'
                    }, {
                        value: 'qual',
                        label: 'Qualitative'
                    }
                ],
                rules:                {
                    'source.name':         [
                        {required: true, message: 'Please enter a Source Name', trigger: 'blur'},
                        {min: 5, message: 'Length should be more than 5 characters', trigger: 'blur'}
                    ],
                    'source.abbreviation': [
                        {required: true, message: 'Please input Source Abbreviation', trigger: 'blur'},
                        {min: 2, message: 'Length should be more than 3 characters.', trigger: 'blur'},
                        {validator: checkDuplicateSourceAbbreviation, trigger: 'blur', allAbbreviations: []}
                    ]

                },
                editSource:           {},
                disallowParentChange: false,
                datePickerOptions:    {
                    disabledDate(time) {
                        return time < new Date(new Date().toDateString());
                    }
                }
            };
        },
        methods:  {
            ...mapActions([
                'loadSourceData'
            ]),
            ...mapMutations({
                deleteSourceState: 'DELETE_SOURCE_DATA',
                updateSourceState: 'UPDATE_SOURCE_DATA'
            }),
            showAddNewSourceDialog:   function (editSourceObject = false) {
                this.visible = true;
                this.resetForm();
                this.$nextTick(function () {
                    if (editSourceObject && editSourceObject.id) {
                        this.form.source          = Object.keys(this.form.source).reduce((a, e) => (a[e] = editSourceObject[e], a), {});
                        this.editSource           = editSourceObject;
                        this.disallowParentChange = this.hasRiskArea(editSourceObject);
                    }
                });
            },
            hasRiskArea(row) {
                return Boolean(
                    Object.values(this.riskAreaData).filter(obj => {
                        if (!(row.risk_areas && row.risk_areas.includes(obj.id)))
                            return false;
                        let sourceWeight = this.sourceWeightData[`${obj.id}-${row.id}`];
                        return Boolean(sourceWeight) && (sourceWeight.weight >= 0);
                    }).length
                );
            },
            submitForm:               async function () {
                let validated = await this.$refs.addNewSourceForm.validate().then(() => true).catch(() => false);
                if (!validated) {
                    this.$notify.error({
                        title:   'Error',
                        message: 'Please correct errors in the Form!'
                    });
                    return;
                }
                this.visible = false;
                this.$emit('update:loading', true);
                let sourceObj = this.form.source;
                await API.riskIndex.source.post([sourceObj]);
                await this.loadSourceData(true);
                this.$emit('selectSource', sourceObj.abbreviation);
                this.$emit('update:loading', false);
                this.resetForm();
            },
            resetForm() {
                if (this.$refs.addNewSourceForm)
                    this.$refs.addNewSourceForm.resetFields();
                if (this.setSourceType) {
                    this.form.source.type = this.setSourceType;
                }
                this.editSource                    = {};
                this.editSourceDateExpectedPublish = null;
                this.disallowParentChange          = false;
            },
            deleteSource:             async function (rows) {
                this.$emit('update:loading', true);
                await API.riskIndex.source.delete({ids: rows.map(x => x.id)});
                this.deleteSourceState(rows.map(x => x.abbreviation));
                this.$emit('update:loading', false);
            },
            updateSource:             async function () {
                let validated = await this.$refs.addNewSourceForm.validate().then(() => true).catch(() => false);
                if (!validated) {
                    this.$notify.error({
                        title:   'Error',
                        message: 'Please correct errors in the Form!'
                    });
                    return;
                }
                this.visible = false;
                this.$emit('update:loading', true);
                let modifiedSource = Object.assign({}, this.editSource, this.form.source);
                let response       = await API.riskIndex.source.put(modifiedSource);
                if (!response) {
                    this.$emit('update:loading', false);
                    return;
                }
                await this.updateSourceState({abbreviation: this.editSource.abbreviation, modifiedSource});
                this.$emit('update:loading', false);
                this.resetForm();
            },
            filterSourceSelectMethod: function (query) {
                let re       = new RegExp(query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), "ig");
                let filtered = Object.values(this.sourceData).filter(source => {
                    re.lastIndex = 0;
                    return re.test(source.name + source.abbreviation);
                });
                this.sortSourceSelectArray(filtered);
            },
            sortSourceSelectArray(data) {
                this.sourceSelect = data.sort((a, b) => a.abbreviation.localeCompare(b.abbreviation));
            },
            timestampToDate:          function (timestamp) {
                return timestamp ? new Date(timestamp * 1000 + (new Date().getTimezoneOffset() * 60000)) : null;
            }
        },
        computed: {
            ...mapState([
                'sourceData', 'sourceWeightData', 'riskAreaData'
            ]),
            editSourceDateExpectedPublish: {
                get: function () {
                    return this.timestampToDate(this.form.source.date_expected_publish);
                },
                set: function (date) {
                    if (date) {
                        let userTimezoneOffset                 = date.getTimezoneOffset() * 60000;
                        this.form.source.date_expected_publish = (date.getTime() - userTimezoneOffset) / 1000;
                    } else this.form.source.date_expected_publish = null;
                }
            }
        },
        watch:    {
            sourceData:    {
                handler: function () {
                    this.rules['source.abbreviation'][2]['allAbbreviations'] = Object.keys(this.sourceData);
                    this.sortSourceSelectArray(Object.values(this.sourceData));
                },
                deep:    true
            },
            setSourceType: function (val) {
                if (val) {
                    // set the source type if it is sent via props
                    this.form.source.type = val;
                }
            }
        },
        mounted() {
            this.rules['source.abbreviation'][2]['allAbbreviations'] = Object.keys(this.sourceData);
            this.sortSourceSelectArray(Object.values(this.sourceData));
        }

    };
</script>

<style scoped lang="scss">
    @import "@/styles/_base.scss";

    .source-abbr {
        width: 100px;
        float: left;
    }

    .source-name {
        width: 300px;
        text-align: left;
        padding: 0 15px;
        float: right;
        color: $color-grey-dark;
        font-size: 11px;
        text-overflow: ellipsis;
        overflow: hidden;
    }

</style>
